import { clientFetchWithIosBridge, type CustomFetcher } from '@chewy/ios-fetch-bridge';
import axios, { type AxiosInstance } from 'axios';

interface CreateAuthenticatedAxiosOptions {
  fetcher?: CustomFetcher;
}

export const createAuthenticatedAxios = ({
  fetcher = clientFetchWithIosBridge,
}: CreateAuthenticatedAxiosOptions = {}): AxiosInstance =>
  axios.create({
    adapter: 'fetch',
    env: {
      fetch: fetcher,
    },
    withCredentials: true,
  });

let browserAuthenticatedAxios: AxiosInstance | undefined;

export const getAuthenticatedAxios = (): AxiosInstance | undefined => {
  if (typeof window === 'undefined') return undefined;

  browserAuthenticatedAxios ??= createAuthenticatedAxios();

  return browserAuthenticatedAxios;
};
